export const resolutionsNum = {
  mobile: 767,
};
